// Error code -> translation key for the wallet app (COI-779, ADR-0032).
//
// Every code here has copy in internal/waas/locales/{en,es}.toml under
// [errors]; the Go test in pkg/errors/errori18n holds the two languages to the
// same key set. A code that is absent renders the canonical message the server
// sent — that is the documented fallback, not a gap.

import { createErrorResolver } from "../../../../global/js/errorCodes.js";

export const ERROR_TRANSLATION_KEYS = {
  AUTH_ACCOUNT_UNAVAILABLE: "errors.auth_account_unavailable",
  AUTH_EMAIL_NOT_RECOGNIZED: "errors.auth_email_not_recognized",
  AUTH_FORBIDDEN: "errors.auth_forbidden",
  AUTH_INVALID_TOKEN: "errors.auth_invalid_token",
  AUTH_OTP_EXPIRED: "errors.auth_otp_expired",
  AUTH_OTP_INVALID: "errors.auth_otp_invalid",
  AUTH_OTP_LOCKED: "errors.auth_otp_locked",
  AUTH_OTP_SEND_FAILED: "errors.auth_otp_send_failed",
  AUTH_PASSKEY_CANCELLED: "errors.auth_passkey_cancelled",
  AUTH_SESSION_EXPIRED: "errors.auth_session_expired",
  AUTH_UNAUTHENTICATED: "errors.auth_unauthenticated",
  INTERNAL: "errors.internal",
  PAYMENT_ALREADY_COMPLETED: "errors.payment_already_completed",
  PAYMENT_BALANCE_UNAVAILABLE: "errors.payment_balance_unavailable",
  PAYMENT_DECLINED_IN_WALLET: "errors.payment_declined_in_wallet",
  PAYMENT_DEPOSIT_ADDRESS_EXPIRED: "errors.payment_deposit_address_expired",
  PAYMENT_DEPOSIT_SETUP_FAILED: "errors.payment_deposit_setup_failed",
  PAYMENT_DEPOSIT_SHORT: "errors.payment_deposit_short",
  PAYMENT_FAILED: "errors.payment_failed",
  PAYMENT_IDEMPOTENCY_CONFLICT: "errors.payment_idempotency_conflict",
  PAYMENT_INSUFFICIENT_BALANCE: "errors.payment_insufficient_balance",
  PAYMENT_INVALID_AMOUNT: "errors.payment_invalid_amount",
  PAYMENT_METHOD_UNAVAILABLE: "errors.payment_method_unavailable",
  PAYMENT_NOT_FOUND: "errors.payment_not_found",
  PAYMENT_NOT_PERMITTED: "errors.payment_not_permitted",
  PAYMENT_PENDING: "errors.payment_pending",
  PAYMENT_PRICING_UNAVAILABLE: "errors.payment_pricing_unavailable",
  PAYMENT_REVERTED_ON_CHAIN: "errors.payment_reverted_on_chain",
  PAYMENT_STATUS_UNCONFIRMED: "errors.payment_status_unconfirmed",
  PAYMENT_UNSUPPORTED_NETWORK: "errors.payment_unsupported_network",
  REQUEST_RATE_LIMITED: "errors.request_rate_limited",
  RESOURCE_CONFLICT: "errors.resource_conflict",
  RESOURCE_NOT_FOUND: "errors.resource_not_found",
  RPC_INVALID_RESPONSE: "errors.rpc_invalid_response",
  RPC_RATE_LIMITED: "errors.rpc_rate_limited",
  RPC_TIMEOUT: "errors.rpc_timeout",
  RPC_UNAVAILABLE: "errors.rpc_unavailable",
  SIGNER_CHALLENGE_EXPIRED: "errors.signer_challenge_expired",
  SIGNER_NONCE_CONFLICT: "errors.signer_nonce_conflict",
  SIGNER_OUT_OF_GAS: "errors.signer_out_of_gas",
  SIGNER_REJECTED: "errors.signer_rejected",
  SIGNER_TIMEOUT: "errors.signer_timeout",
  SIGNER_UNAVAILABLE: "errors.signer_unavailable",
  SIGNER_UNDERPRICED: "errors.signer_underpriced",
  SIGNER_WALLET_SETUP_FAILED: "errors.signer_wallet_setup_failed",
  UPSTREAM_INVALID_RESPONSE: "errors.upstream_invalid_response",
  UPSTREAM_TIMEOUT: "errors.upstream_timeout",
  UPSTREAM_UNAVAILABLE: "errors.upstream_unavailable",
  VALIDATION_INVALID_EMAIL: "errors.validation_invalid_email",
  VALIDATION_INVALID_FIELD: "errors.validation_invalid_field",
  VALIDATION_INVALID_REQUEST: "errors.validation_invalid_request",
  VALIDATION_REQUIRED_FIELD: "errors.validation_required_field",
};

// translateError(source, fallback) resolves an error envelope, an Error thrown
// by HttpService, or a parsed error body into the copy to display.
export const translateError = createErrorResolver(ERROR_TRANSLATION_KEYS);
